import Vue from 'vue'
import Vuex from 'vuex'

import AdminModel from '@/models/admin.model'

Vue.use(Vuex)

const adminModel =  new AdminModel()
const admin = adminModel.getData()

const store = new Vuex.Store({
    state: {
     admin
    },
    getters: {
        admin: state => state.admin
    },
    mutations: {
      setAdmin (state, admin) {
        state.admin.id = admin.id,
        state.admin.email = admin.email,
        state.admin.totens = admin.totens,
        state.admin.selectedTotem = admin.selectedTotem
      },
      clearAdmin (state) {
        state.admin.id = '',
        state.admin.email = '',
        state.admin.totens = [],
        state.admin.selectedTotem = {}
      },

    }
})

export default store;